import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import { LOCALIZED_QUICK_ACTIONS } from '../../constants';
import { NotificationCard } from '../NotificationCard';
import { QuickActions } from '../QuickActions';
import { UserChatBubble } from '../UserChatBubble';
import { getResponseConfig } from './helpers';

function AssistantResponse({
  businessEntity = {},
  hasPositiveResponse = false,
  loading = false,
  onClickQuickAction,
  prompt,
  results = {}
}) {
  const { formatMessage: fm } = useIntl();
  const dashboardPath = useDashboardPath();

  const { actions, message } = getResponseConfig({
    results,
    businessEntity,
    fm,
    dashboardPath,
    hasPositiveResponse
  });

  if (loading) {
    return (
      <Stack gap={3}>
        <UserChatBubble message={prompt} />
        <Skeleton
          variant="rounded"
          width="100%"
          height="6rem"
        />
      </Stack>
    );
  }

  return (
    <Stack gap={3}>
      <UserChatBubble message={prompt} />
      <NotificationCard
        actions={actions}
        color="background.purple.main"
        message={message}
        isRawText
      />
      {!hasPositiveResponse && (
        <QuickActions
          actions={LOCALIZED_QUICK_ACTIONS}
          onClick={onClickQuickAction}
        />
      )}
    </Stack>
  );
}

AssistantResponse.propTypes = {
  businessEntity: PropTypes.shape({
    domesticJurisdiction: PropTypes.string,
    name: PropTypes.string
  }),
  hasPositiveResponse: PropTypes.bool,
  loading: PropTypes.bool,
  onClickQuickAction: PropTypes.func,
  prompt: PropTypes.string.isRequired,
  results: PropTypes.shape({
    amendments: PropTypes.bool,
    annualReport: PropTypes.bool
  })
};

export default AssistantResponse;
